import React from 'react';
import { I18n } from '../../core/i18n/I18n';

var HeaderCell = function HeaderCell(_ref) {
  var onSortColumn = _ref.onSortColumn,
      sortable = _ref.sortable,
      sorting = _ref.sorting,
      title = _ref.title;
  return /*#__PURE__*/React.createElement("th", title ? {
    scope: 'col'
  } : {}, sortable === false ? /*#__PURE__*/React.createElement(I18n, null, title) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(I18n, null, title), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onSortColumn
  }, sorting === 'desc' ? /*#__PURE__*/React.createElement("span", null, "\u2193") : sorting === 'asc' ? /*#__PURE__*/React.createElement("span", null, "\u2191") : /*#__PURE__*/React.createElement("span", null, "\u2013"))));
};

export default HeaderCell;